module.exports = __webpack_public_path__ + "static/media/fondogris_Dashport.f3dd6ad6.jpg";